// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quantity {
  text-align: left;
  padding-left: 5%;
}

.quantityInfo {
  font-weight: 600;
  display: block;
}

.list {
  margin-top: 3%;
  margin-bottom: 5%;
}

.details {
  background-color: var(--foreground-tertiary);
  border: none;
}

.fa-angle-down {
  font-weight: 600;
}

.fa-angle-right {
  font-weight: 600;
}

.itemDetails {
  padding-left: 10px;
}

.info {
  font-weight: 600;
  margin-top: 5%;
}

label.checkbox > span:before {
  /* stylelint-disable-next-line*/
  font: normal normal normal 14px/1 FontAwesome;
  text-rendering: auto;
  content: " ";
  width: 20px;
  height: 20px;
  border-radius: 2px;
  display: inline-block;
  line-height: 18px;
  font-size: 17px;
  margin-left: -14px;
  font-weight: 100;
  text-align: center;
  vertical-align: top;
  margin-right: 10px;
  cursor: pointer;
  border: 1px solid var(--color-secondary);
}

.custom-select {
  padding: 3% 4% 3% 5%;
  font-size: 14px;
  font-weight: 600;
  border: 1px solid #999999;
}

.header-title {
  color: var(--color-interaction-text);
}

.error {
  margin: 20px 0px 0px 0px;
}

.card {
  width: 100%;
  padding: 0px 15px 0px 15px;
  margin-top: 20px;
}

@media (max-width: 767px) {
  .marginTest {
    margin-top: 20px;
  }
}
@media (min-width: 768px) {
  .marginTest {
    margin-top: -145px;
  }
}
.m-screen-header-wrapper {
  position: relative;
  z-index: 100;
}

.text-right {
  text-align: right;
}

.information-checkbox-container {
  padding: 10px;
}

.information-checkbox-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.information-checkbox-input {
  cursor: pointer;
  position: static;
  margin-left: 0;
  margin-right: 8px;
}

.information-checkbox-label {
  cursor: pointer;
  font-size: 12px;
  margin-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./ClientApp/src/app/desktop/d-landing-page/return-items/return-items.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,gBAAA;AACF;;AACA;EACE,gBAAA;EACA,cAAA;AAEF;;AAAA;EACE,cAAA;EACA,iBAAA;AAGF;;AADA;EACE,4CAAA;EACA,YAAA;AAIF;;AAFA;EACE,gBAAA;AAKF;;AAHA;EACE,gBAAA;AAMF;;AAJA;EACE,kBAAA;AAOF;;AAJA;EACE,gBAAA;EACA,cAAA;AAOF;;AAHA;EACE,+BAAA;EACA,6CAAA;EACA,oBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EAEA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,wCAAA;AAKF;;AADA;EACE,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAIF;;AAFA;EACE,oCAAA;AAKF;;AAHA;EACE,wBAAA;AAMF;;AAHA;EACE,WAAA;EACA,0BAAA;EACA,gBAAA;AAMF;;AAHA;EACE;IACE,gBAAA;EAMF;AACF;AAHA;EACE;IACE,kBAAA;EAKF;AACF;AAFA;EACE,kBAAA;EACA,YAAA;AAIF;;AADA;EACE,iBAAA;AAIF;;AADA;EACE,aAAA;AAIF;;AADA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAIF;;AADA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAIF;;AADA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;AAIF","sourcesContent":[".quantity {\n  text-align: left;\n  padding-left: 5%;\n}\n.quantityInfo {\n  font-weight: 600;\n  display: block;\n}\n.list {\n  margin-top: 3%;\n  margin-bottom: 5%;\n}\n.details {\n  background-color: var(--foreground-tertiary);\n  border: none;\n}\n.fa-angle-down {\n  font-weight: 600;\n}\n.fa-angle-right {\n  font-weight: 600;\n}\n.itemDetails {\n  padding-left: 10px;\n}\n\n.info {\n  font-weight: 600;\n  margin-top: 5%;\n}\n\n// checkbox css\nlabel.checkbox > span:before {\n  /* stylelint-disable-next-line*/\n  font: normal normal normal 14px/1 FontAwesome;\n  text-rendering: auto;\n  content: \" \";\n  width: 20px;\n  height: 20px;\n\n  border-radius: 2px;\n  display: inline-block;\n  line-height: 18px;\n  font-size: 17px;\n  margin-left: -14px;\n  font-weight: 100;\n  text-align: center;\n  vertical-align: top;\n  margin-right: 10px;\n  cursor: pointer;\n  border: 1px solid var(--color-secondary);\n}\n\n//dropdown\n.custom-select {\n  padding: 3% 4% 3% 5%;\n  font-size: 14px;\n  font-weight: 600;\n  border: 1px solid #999999;\n}\n.header-title {\n  color: var(--color-interaction-text);\n}\n.error {\n  margin: 20px 0px 0px 0px;\n}\n\n.card {\n  width: 100%;\n  padding: 0px 15px 0px 15px;\n  margin-top: 20px;\n}\n\n@media (max-width: 767px) {\n  .marginTest {\n    margin-top: 20px;\n  }\n}\n\n@media (min-width: 768px) {\n  .marginTest {\n    margin-top: -145px;\n  }\n}\n\n.m-screen-header-wrapper {\n  position: relative;\n  z-index: 100;\n}\n\n.text-right {\n  text-align: right;\n}\n\n.information-checkbox-container {\n  padding: 10px;\n}\n\n.information-checkbox-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.information-checkbox-input {\n  cursor: pointer;\n  position: static;\n  margin-left: 0;\n  margin-right: 8px;\n}\n\n.information-checkbox-label {\n  cursor: pointer;\n  font-size: 12px;\n  margin-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
